import React from 'react';

import DayLoading from './day-loading.png';
import NightLoading from './night-loading.png';

import './index.css';

const Loading = ({ theme = 'day' }) => (
    <img
        src={theme === 'day' ? DayLoading : NightLoading }
        width='40'
        height='40'
        alt='Loading...'
        className='loading-indicator'
    />
)

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js